module.exports = "<div id=\"map\" [style.height]=\"mapHeight\" *ngIf=\"selectable && !isMultipleState\"></div>\r\n<div id=\"map2\" [style.height]=\"mapHeight\" *ngIf=\"!selectable\"></div>\r\n<div id=\"map3\" [style.height]=\"mapHeight\" *ngIf=\"selectable && isMultipleState\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/us-states-vector-map/us-states-vector-map.component.html
// module id = ./src/app/shared/components/us-states-vector-map/us-states-vector-map.component.html
// module chunks = main